import Footer from '../components/Footer';
import '../App.css';
import MSAPrivacyPolicy from '../components/conveniomarco/MSAPrivacyPolicy';
import { ServiceEnums } from '../enums/ServicesEnum';

export default function ConvenioMarcoPrivacyPolicy(){
    return (
        <>
            <MSAPrivacyPolicy />
            <div className='information-section'>
                <Footer isPolicy={true} origin={ServiceEnums.MSA}/>  
            </div>     
        </>
    )
}